const isCartPage = window.location.pathname === '/cart/';

const getVerifyFitmentLabelHtml = (fits, vehicleLabel) => {
  const icon =
    fits === 'yes'
      ? `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enable-background="new 0 0 24 24"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="#000000"
      >
        <rect fill="none" height="24" width="24"></rect>
        <path
          d="M22,5.18L10.59,16.6l-4.24-4.24l1.41-1.41l2.83,2.83l10-10L22,5.18z M19.79,10.22C19.92,10.79,20,11.39,20,12 c0,4.42-3.58,8-8,8s-8-3.58-8-8c0-4.42,3.58-8,8-8c1.58,0,3.04,0.46,4.28,1.25l1.44-1.44C16.1,2.67,14.13,2,12,2C6.48,2,2,6.48,2,12 c0,5.52,4.48,10,10,10s10-4.48,10-10c0-1.19-0.22-2.33-0.6-3.39L19.79,10.22z"
        ></path>
      </svg>`
      : `
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
        <path d="M0 0h24v24H0V0z" fill="none"></path>
        <path
          d="M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
        ></path>
      </svg>`;

  return `
    ${icon}
    ${fits === 'yes' ? 'Verified to fit' : 'Does not fit'}
    <span class="cm vehicle-name">${vehicleLabel}</span>`;
};

const hideCartVerifyFitmentLabels = () =>
  window.document
    .querySelectorAll('.woocommerce-cart-form__cart-item .ufs-fitment-check')
    .forEach((e) => e.classList.add('d-none'));

const updateCartVerifyFitmentLabels = (vehicle) => {
  const cartItemContainers = [...window.document.querySelectorAll('.woocommerce-cart-form__cart-item')];
  const vehicleLabel = Object.values(vehicle).join(' ');

  cartItemContainers.forEach((cartItem) => {
    const variationId = cartItem.querySelector('.product-quantity a').getAttribute('data-product_id');

    if (!variationId || !cartItem.querySelector('.ufs-fitment-check')) {
      return;
    }

    window.Convermax.verifyFitmentAsync(variationId, vehicle)
      .then((fits) => {
        const verify = cartItem.querySelector('.ufs-fitment-check');
        if (fits !== 'yes' && fits !== 'no') {
          verify.classList.add('d-none');
          return;
        }

        verify.classList.remove('d-none');
        if (fits === 'yes') {
          verify.classList.remove('no-fit');
          verify.classList.add('fit');
          verify.innerHTML = getVerifyFitmentLabelHtml(fits, vehicleLabel);
        } else {
          verify.classList.remove('fit');
          verify.classList.add('no-fit');
          verify.innerHTML = getVerifyFitmentLabelHtml(fits, vehicleLabel);
        }
      })
      .catch(() => {
        hideCartVerifyFitmentLabels();
      });
  });
};

export const onVehicleSelected = (vehicle) => {
  if (isCartPage) {
    updateCartVerifyFitmentLabels(vehicle);
  }
};

export const onVehicleDiscarded = () => {
  if (isCartPage) {
    hideCartVerifyFitmentLabels();
  }
};

export const AfterInit = () => {
  const vehicle = window.Convermax.getVehicle();

  if (isCartPage) {
    if (Object.keys(vehicle).length > 0) {
      updateCartVerifyFitmentLabels(vehicle);
    } else {
      hideCartVerifyFitmentLabels();
    }
  }
};
